import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "public-layout" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header-content" }
const _hoisted_4 = { class: "header-nav" }
const _hoisted_5 = { class: "main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Footer = _resolveComponent("Footer")!
  const _component_FeedbackButton = _resolveComponent("FeedbackButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Prec8",
          class: "header-logo",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
        }),
        _createElementVNode("nav", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goToHowItWorks && _ctx.goToHowItWorks(...args))),
            class: "nav-link"
          }, "How it works"),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.goToSignIn && _ctx.goToSignIn(...args))),
            class: "nav-link"
          }, "Sign In")
        ])
      ])
    ]),
    _createElementVNode("main", _hoisted_5, [
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ]),
    _createVNode(_component_Footer),
    _createVNode(_component_FeedbackButton)
  ]))
}